import { useState } from "react";
import { Loader2, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader } from "@/components/common/States";
import { DraftCard } from "@/components/email/DraftCard";
import { NewDraftDialog } from "@/components/email/NewDraftDialog";
import { useFetch } from "@/lib/hooks";
import { useWorkspace } from "@/context/WorkspaceContext";

const TABS = [["pending_approval", "Awaiting approval"], ["approved", "Ready to send"], ["sent", "Sent"], ["rejected", "Rejected"]];

export default function Email() {
  const { can } = useWorkspace();
  const [tab, setTab] = useState("pending_approval");
  const [open, setOpen] = useState(false);
  const { data, loading, reload } = useFetch("/email-drafts", { status: tab });
  return (
    <div className="space-y-5" data-testid="email-page">
      <PageHeader eyebrow="Outreach" title="Email" description="AI drafts emails from verified research. Every email is reviewed and approved here, then sent from your own email app so replies come straight to your inbox."
        actions={can("write") && <Button onClick={() => setOpen(true)} data-testid="email-new-button"><Plus className="mr-1.5 h-4 w-4" />New AI draft</Button>} />
      <Tabs value={tab} onValueChange={setTab}><TabsList>{TABS.map(([k, l]) => <TabsTrigger key={k} value={k} data-testid={`email-tab-${k}`}>{l}</TabsTrigger>)}</TabsList></Tabs>
      {loading && !data ? <Loader2 className="h-5 w-5 animate-spin" />
        : (data || []).length === 0 ? <p className="rounded-lg border border-dashed p-6 text-sm text-muted-foreground" data-testid="email-empty">No emails here.</p>
        : <div className="grid gap-4 xl:grid-cols-2">{data.map((d) => <DraftCard key={`${d.id}-${d.updated_at}`} d={d} onChanged={reload} />)}</div>}
      <NewDraftDialog open={open} onOpenChange={setOpen} onCreated={() => { setTab("pending_approval"); reload(); }} />
    </div>
  );
}
